<span class="inline-flex translate-y-px px-1" [pTooltip]="message" [tooltipPosition]="position">
  <i class="pi pi-info-circle text-sm" [ngClass]="iconClass"></i>
</span>
